// Diagnóstico de "Generar subtítulos" del Estudio de Video.
//
// El flujo podía fallar sin dejar rastro en NINGÚN lado —ni fila en
// `executions`, ni transcript cacheado, ni log— y encima los cuatro motivos
// posibles terminaban en el mismo texto: "No pudimos obtener la URL del clip.
// Probá volver a subir el archivo". Cuando una usuaria reportó que no le
// andaban, no hubo forma de saber qué le había pasado: la base no tenía nada
// que mirar (ADR-2026-09-11-los-subtitulos-fallan-sin-dejar-rastro).
//
// Acá vive la parte pura: qué se le dice al usuario en cada paso. El registro
// (PostHog) lo hace el call site, que es quien tiene el contexto del clip.

/** En qué paso del flujo se rompió. */
export type PasoDeSubtitulos =
  /** El clip TIENE archivo, pero firmar su URL devolvió null (Storage). */
  | 'firmar_url'
  /** El clip no tiene ni `storagePath` ni un `src` usable. */
  | 'sin_archivo'
  /** No hay sesión de Supabase. */
  | 'sin_sesion'
  /** El servicio de transcripción respondió que no. */
  | 'transcribir'
  /** Transcribió bien, pero no hay una sola palabra: el clip no tiene voz. */
  | 'sin_habla';

export interface FalloDeSubtitulos {
  paso: PasoDeSubtitulos;
  /** Motivo crudo del servicio, cuando lo hay. Se muestra tal cual. */
  detalle?: string;
}

export const MENSAJE_GENERICO_SUBTITULOS =
  'No pudimos generar los subtítulos. Probá de nuevo en un momento.';

/**
 * Qué ve el usuario según dónde se rompió.
 *
 * La distinción que importa es `firmar_url` vs `sin_archivo`: firmar puede
 * fallar por un hipo de Storage con el archivo intacto, y ahí mandar a
 * "volver a subir el archivo" es hacerle rehacer trabajo al pedo.
 */
export function mensajeDeFalloDeSubtitulos(f: FalloDeSubtitulos): string {
  switch (f.paso) {
    case 'firmar_url':
      return 'No pudimos abrir el archivo de este clip en este momento. Reintentá en unos segundos — el archivo está guardado, no hace falta volver a cargarlo.';
    case 'sin_archivo':
      return 'Este clip todavía no tiene un archivo asociado. Si lo acabás de agregar, esperá a que termine de subir y probá de nuevo.';
    case 'sin_sesion':
      return 'Se cerró tu sesión. Recargá la página y volvé a intentar.';
    case 'sin_habla':
      return 'Este clip no tiene voz que transcribir, así que no hay nada para subtitular. Probá con un clip que tenga a alguien hablando.';
    case 'transcribir':
      return f.detalle?.trim() ? f.detalle.trim() : MENSAJE_GENERICO_SUBTITULOS;
    default:
      return MENSAJE_GENERICO_SUBTITULOS;
  }
}
